import { render, staticRenderFns } from "./uploadPayVoucher.vue?vue&type=template&id=3f40f674&scoped=true"
import script from "./uploadPayVoucher.vue?vue&type=script&setup=true&lang=js"
export * from "./uploadPayVoucher.vue?vue&type=script&setup=true&lang=js"
import style0 from "./uploadPayVoucher.vue?vue&type=style&index=0&id=3f40f674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f40f674",
  null
  
)

export default component.exports